import { ExecuteResultType } from "../monitoring-types";
import IoTDeviceComp from "./IoTDeviceComp";
import IotTemperatureAverage from "./IotTemperatureAverage";

type Props = {
  devices: ExecuteResultType[];
  buildingId: string;
  partnerId: string;
};

const IotDeviceList = ({ devices, buildingId, partnerId }: Props) => {
  if (devices.length > 0 && devices[0].labelType === "온도") {
    return <IotTemperatureAverage devices={devices} />;
  }
  return (
    <>
      {devices
        .sort((a, b) => (a.internalDisplayName > b.internalDisplayName ? 1 : -1))
        .map((device, idx: number) => {
          return (
            <IoTDeviceComp
              key={`floor-${device.labelType}-${idx}`}
              device={device}
              buildingId={String(buildingId)}
              partnerId={String(partnerId)}
              idx={idx}
            />
          );
        })}
    </>
  );
};

export default IotDeviceList;
